import { UserInfo } from "@app/user/UserContext";

export function networkPortfolioManagementColumnVisibilityStorageKey(user: UserInfo): string {
  return `${user.userId}_networkPortfolioManagementColumnVisibility`;
}
